// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-5EI","clinicsSelect":"styles_clinicsSelect__2StK6"};